export enum PropertyMainUsage {
    PrincipalResidence = 'PrincipalResidence',
    SecondaryResidence = 'SecondaryResidence',
    RentalResidence = 'RentalResidence',
    Other = 'Other',
}
